import { API_TAG_TYPES } from "@/shared/api";

/**
 * The server reports when a document is fully settled, so caches drop the
 * moment it says so. The delay stays only for paths that cannot ask.
 */
export const POST_SIGNING_INVALIDATION_DELAY = 5000;

/** Polling cadence while the server finalizes: the read is DB-only and cheap. */
export const FINALIZING_POLL_INTERVAL = 2000;

/** A stuck worker must never hold the modal open forever. */
export const FINALIZATION_TIMEOUT_MS = 45000;

export const POST_SIGNING_TAGS = API_TAG_TYPES.filter(function isInvalidatable(tag) {
  return tag !== "Auth";
});

/**
 * Provider reads are expensive and a browser polls them on a timer. Repeated
 * failures back off with jitter so a struggling SIGEX is not hammered by every
 * open tab at once.
 */
export const POLL_BACKOFF_STEPS_MS = [3000, 5000, 10000, 20000, 30000];

export function withPollJitter(intervalMs: number): number {
  return Math.round(intervalMs * (0.85 + Math.random() * 0.3));
}

export function getBackoffInterval(consecutiveFailures: number): number {
  const step = Math.min(consecutiveFailures, POLL_BACKOFF_STEPS_MS.length) - 1;
  return withPollJitter(POLL_BACKOFF_STEPS_MS[Math.max(0, step)]);
}
